import React from "react";
import { ColumnsLayout } from "@components";
import { TermsOfUse } from "./TermsOfUse";

export const AgbPage = () => {
  return (
    <ColumnsLayout>
      <TermsOfUse />
    </ColumnsLayout>
  );
};
